import { useNavigate, useLocation } from "react-router-dom";
import { useLayout } from "@/contexts/UseLayout";
import { useState } from "react";
import { useDevice } from "@/helpers/UseDevice";
import {
  hasAdLinkAccess,
  hasGoOnAccess,
} from "@/components/utils/NiveisDeAcesso";

export function ViewToggle() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userLogged } = useLayout();
  const { isMobile } = useDevice();
  const [isHovered, setIsHovered] = useState(false);

  // Verifica se o usuário tem acesso ao GoOn E ao Ad Link simultaneamente
  const hasAccess = hasGoOnAccess(userLogged) && hasAdLinkAccess(userLogged);

  // Não renderiza o botão se não tiver acesso ou se for mobile
  if (!hasAccess || isMobile) return null;

  // Determina qual view está ativa
  const isAdLinkView = location.pathname.startsWith("/ad-link");

  const handleToggle = () => {
    if (isAdLinkView) {
      navigate("/home");
    } else {
      navigate("/ad-link");
    }
  };

  return (
    <div
      className="fixed bottom-6 right-6 z-50"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        onClick={handleToggle}
        className="group relative flex items-center gap-3 bg-white hover:bg-cinza-50 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 p-1 pr-3 border border-cinza-200"
        title={isAdLinkView ? "Mudar para GoOn" : "Mudar para Ad-Link"}
      >
        {/* Ícone/Label */}
        <div className="flex items-center gap-2">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300`}
          >
            {isAdLinkView ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#153DCE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#153DCE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
              </svg>
            )}
          </div>

          {/* Texto que expande no hover */}
          <div
            className={`overflow-hidden transition-all duration-300 ${
              isHovered ? "max-w-[150px] opacity-100 pr-2" : "max-w-0 opacity-0"
            }`}
          >
            <div className="text-sm font-medium text-cinza-700 whitespace-nowrap">
              {isAdLinkView ? (
                <div>
                  <div className="text-xs text-cinza-500">Mudar para</div>
                  <div className="font-semibold text-verde-600">Ad-Desk</div>
                </div>
              ) : (
                <div>
                  <div className="text-xs text-cinza-500">Mudar para</div>
                  <div className="font-semibold text-azul-600">Ad-Link</div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Indicador de troca */}
        <div
          className={`absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 group-hover:bg-azul-600`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 text-azul-600 group-hover:text-white"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="17 1 21 5 17 9" />
            <path d="M3 11V9a4 4 0 0 1 4-4h14" />
            <polyline points="7 23 3 19 7 15" />
            <path d="M21 13v2a4 4 0 0 1-4 4H3" />
          </svg>
        </div>
      </button>
    </div>
  );
}
